import owd from 'owd/owd';

export default class Apply extends owd.Component {
	init() {
        this.target = this.$element.data('apply');
        this.$target = $(this.target)
        this.bind();
	}

	bind() {
        this.on('click', (e) => {
            e.preventDefault();
            //this.$element.addClass('active');
            this.$target.fadeIn(300);
        });

        this.on('click', this.$target.find('.close'), (e) => {
            e.preventDefault();
            this.$target.fadeOut(300, () => {
                // setTimeout( () => {
                //     this.$element.removeClass('active');
                // }, 250);
            });
        });

    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('apply', {
    component: Apply
});
